import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { FieldValues } from 'react-hook-form';
import styles from './ErrorMessage.module.css';
import { ErrorMessageProps } from './types';
import type { ReactNode } from 'react';
function ErrorMessageText(t0) {
  const $ = _c(6);
  const {
    name,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.helpInline, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${name}-error`;
  let t3;
  if ($[2] !== children || $[3] !== t1 || $[4] !== t2) {
    t3 = <div className={t1} id={t2}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default ErrorMessageText;